import { ScheduleTaskForm } from './types';

export const validateProcessTemplateForm = (values: Record<string, unknown>) => {

  const errors: Record<string, string> = {};
  const tasks = values.scheduleTasks as ScheduleTaskForm[] | undefined;

  if (!Array.isArray(tasks) || tasks.length === 0) {

    errors.scheduleTasks = 'resources.process-templates.text.schedule_tasks_required';

  }

  return errors;

};
